import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LoggerService, tryNormalizeHttpError } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { CustomStoreFinderConnector } from '../../connectors/custom-store-finder.connector';
import { CustomFindStores, CustomFindStoresFail, CustomFindStoresSuccess, FIND_STORES } from '../actions/custom-store-finder.actions';

@Injectable()
export class CustomFindStoresEffect {
  constructor(private actions$: Actions, private storeFinderConnector: CustomStoreFinderConnector) {}
  protected logger = inject(LoggerService);
  findStores$: Observable<CustomFindStoresSuccess | CustomFindStoresFail> = createEffect(() =>
    this.actions$.pipe(
      ofType(FIND_STORES),
      map((action: CustomFindStores) => action.payload),
      mergeMap((payload) =>
        this.storeFinderConnector.search().pipe(
          map((data) => {
            return new CustomFindStoresSuccess(data);
          }),
          catchError((error) => of(new CustomFindStoresFail(tryNormalizeHttpError(error, this.logger))))
        )
      )
    )
  );
}

export const effectsStoreFinder: any[] = [CustomFindStoresEffect];
